/**
 * StandOut WordPress Theme
 * Theme-wide functionality initialization
 *
 * @package StandOut
 * @since 2.0.0
 */
import { onDomReady } from "@utils/dom-ready";
onDomReady(() => {
    // Navigation (conditional loading)
    const navigation = document.querySelector(".main-navigation");
    const scrollProgress = document.querySelector(".scroll-progress-container");
    if (navigation) {
        import("./navigation").then(({ ThemeNavigation }) => {
            new ThemeNavigation();
        });
        // Fade in navigation and scroll progress (CSS transition handles the 2s duration)
        navigation.style.opacity = "1";
        if (scrollProgress) {
            scrollProgress.style.opacity = "1";
        }
    }
});
// Color detection system (initializes after GSAP is ready)
const initColorDetectionSystem = () => {
    import("./background-color-detection").then(({ initBackgroundColorDetection }) => {
        initBackgroundColorDetection();
    });
};
if (typeof gsap !== "undefined") {
    initColorDetectionSystem();
}
else {
    window.addEventListener("gsap-ready", initColorDetectionSystem);
}
